import React, { createContext, useContext, useState } from 'react';
import { RheaTheme, defaultRheaTheme } from './rheaTheme';
import './rheaTheme.css';

interface RheaThemeContextType {
  theme: RheaTheme;
  setTheme: (theme: RheaTheme) => void;
}

const RheaThemeContext = createContext<RheaThemeContextType | undefined>(undefined);

export const useRheaTheme = () => {
  const context = useContext(RheaThemeContext);
  if (!context) {
    throw new Error('useRheaTheme must be used within a RheaThemeProvider');
  }
  return context;
};

interface RheaThemeProviderProps {
  children: React.ReactNode;
  initialTheme?: RheaTheme;
}

export const RheaThemeProvider: React.FC<RheaThemeProviderProps> = ({
  children,
  initialTheme = defaultRheaTheme,
}) => {
  const [theme, setTheme] = useState<RheaTheme>(initialTheme);

  return (
    <RheaThemeContext.Provider value={{ theme, setTheme }}>
      {children}
    </RheaThemeContext.Provider>
  );
}; 